import { IAdminLogin } from "@/pages/auth/_misc/type";
import { useSessionStorage } from "usehooks-ts";
export const useAdminDetail = () => {
  const [adminLogin, setAdminLogin, removeAdminLogin] =
    useSessionStorage<IAdminLogin>("admin_details", {} as IAdminLogin);

  return {
    setAdminLogin,
    adminLogin,
    removeAdminLogin,
  };
};
